export default __webpack_public_path__ + "static/media/a023-06.4b018722.png";